<script setup lang="ts">
withDefaults(defineProps<{
  color?: string;
}>(), {
  color: "#0F8577"
});
</script>

<template>
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="none">
  <path
    d="M14.3985 2.6121C14.6318 2.39501 14.9422 2.275 15.2643 2.27738C15.5864 2.27976 15.895 2.40436 16.1249 2.62487C16.3548 2.84539 16.488 3.14458 16.4965 3.45931C16.5051 3.77405 16.3882 4.0797 16.1705 4.31179L8.06569 13.8619C7.95207 13.9816 7.81494 14.0776 7.66249 14.1442C7.51005 14.2108 7.34542 14.2467 7.17845 14.2497C7.01149 14.2528 6.84562 14.2228 6.69075 14.1618C6.53589 14.1007 6.39521 14.0097 6.27714 13.8943L1.61945 9.22696C1.49742 9.11582 1.39954 8.98179 1.33166 8.83286C1.26377 8.68394 1.22727 8.52318 1.22433 8.36016C1.22138 8.19715 1.25206 8.03523 1.31453 7.88406C1.377 7.73289 1.46998 7.59556 1.58792 7.48028C1.70586 7.36499 1.84635 7.27411 2.00101 7.21305C2.15567 7.15199 2.32132 7.122 2.48809 7.12488C2.65486 7.12775 2.81933 7.16343 2.97169 7.22979C3.12405 7.29614 3.26117 7.39182 3.37488 7.5111L7.11842 11.2833L14.367 2.64772C14.3774 2.63525 14.3885 2.62337 14.4002 2.6121H14.3985Z"
    :fill="color"
  />
</svg>
</template>